module.exports = new __parcel__URL__("Planet_B_teaser_zh-tw.3ec37588.webp").toString();